import { render, staticRenderFns } from "./InstitutionPicker.vue?vue&type=template&id=445dc752&"
import script from "./InstitutionPicker.vue?vue&type=script&lang=js&"
export * from "./InstitutionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports